import React from "react";
import "./Footer.css";
import { NavLink } from "react-router-dom";
import { BsLinkedin, BsGithub } from "react-icons/bs";
import { SiLeetcode } from "react-icons/si";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo-row">
            <div className="footer-logo-dot" />
            <span className="footer-logo">Abhinav.dev</span>
          </div>
          <p className="footer-tagline">
            Full-Stack Engineer · React · Node.js · AWS
          </p>
          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/in/abhinav9984"
              target="_blank"
              rel="noreferrer"
              className="footer-social-icon"
              aria-label="LinkedIn"
            >
              <BsLinkedin />
            </a>
            <a
              href="https://github.com/Abhinav4005"
              target="_blank"
              rel="noreferrer"
              className="footer-social-icon"
              aria-label="GitHub"
            >
              <BsGithub />
            </a>
            <a
              href="https://leetcode.com/Abhinavpathak45/"
              target="_blank"
              rel="noreferrer"
              className="footer-social-icon"
              aria-label="LeetCode"
            >
              <SiLeetcode />
            </a>
          </div>
        </div>

        {/* Nav links */}
        <div className="footer-nav">
          <p className="footer-nav-title">Navigation</p>
          <div className="footer-nav-links">
            <NavLink to="/" end>Home</NavLink>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/skill">Skills</NavLink>
            <NavLink to="/project">Projects</NavLink>
            <NavLink to="/contact">Contact</NavLink>
          </div>
        </div>

        {/* Contact quick */}
        <div className="footer-contact">
          <p className="footer-nav-title">Contact</p>
          <div className="footer-contact-list">
            <a href="mailto:abhinavpathak9984@gmail.com" className="footer-contact-item">
              abhinavpathak9984@gmail.com
            </a>
            <a href="tel:+919682906846" className="footer-contact-item">
              +91-9682906846
            </a>
            <span className="footer-contact-item">India</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Abhinav Kumar Pathak · All Rights Reserved</span>
        <span>Built with React.js</span>
      </div>
    </footer>
  );
};

export default Footer;
